var dateHelper = require("../../../utils/date_helpers");

function createGridLineRender(gantt){
	function _render_grid_item(item, view) {
		//if (!_is_grid_visible.call(this))
		//	return null;

		var columns = view.getGridColumns();
		var config = view.$getConfig();

		var cells = [];
		var width = 0;
		var has_child;
		for (var i = 0; i < columns.length; i++) {
			var last = i == columns.length - 1;
			var col = columns[i];
			var cell;

			var value;
			var textValue;
			if (col.name == "add") {
				var aria = gantt._waiAria.gridAddButtonAttrString(col);

				value = "<div " + aria + " class='gantt_add'></div>";
				textValue = "";
			} else {
				if (col.template)
					value = col.template(item);
				else
					value = item[col.name];

				if (dateHelper.isDate(value))
					value = gantt.templates.date_grid(value, item);
				textValue = value;
				value = "<div class='gantt_tree_content'>" + value + "</div>";
			}
			var css = "gantt_cell" + (last ? " gantt_last_cell" : "");

			var tree = "";
			if (col.tree) {
				for (var j = 0; j < item.$level; j++)
					tree += gantt.templates.grid_indent(item);

				has_child = gantt._has_children(item.id);
				if (has_child) {
					tree += gantt.templates.grid_open(item);
					tree += gantt.templates.grid_folder(item);
				} else {
					tree += gantt.templates.grid_blank(item);
					tree += gantt.templates.grid_file(item);
				}
			}
			var style = "width:" + (col.width - (last ? 1 : 0)) + "px;";
			if (this.defined(col.align))
				style += "text-align:" + col.align + ";";

			var aria = gantt._waiAria.gridCellAttrString(col, textValue);

			cell = "<div class='" + css + "' style='" + style + "' " + aria + ">" + tree + value + "</div>";
			cells.push(cell);
		}
		var css = gantt.getGlobalTaskIndex(item.id) % 2 === 0 ? "" : " odd";
		css += (item.$transparent) ? " gantt_transparent" : "";

		css += (item.$dataprocessor_class ? " " + item.$dataprocessor_class : "");

		if (gantt.templates.grid_row_class) {
			var css_template = gantt.templates.grid_row_class.call(gantt, item.start_date, item.end_date, item);
			if (css_template)
				css += " " + css_template;
		}

		if (gantt.getState().selected_task == item.id) {
			css += " gantt_selected";
		}
		var el = document.createElement("div");
		el.className = "gantt_row" + css;
		el.style.height = config.row_height + "px";
		el.style.lineHeight = (config.row_height) + "px";
		
		if(view.$config.item_attribute){
			el.setAttribute(view.$config.item_attribute, item.id);
		}

		gantt._waiAria.taskRowAttr(item, el);

		el.innerHTML = cells.join("");
		return el;
	}

	return _render_grid_item;
}

module.exports = createGridLineRender;




//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/render/task_grid_line_render.js
// module id = 44
// module chunks = 0